import SingleColorPickerPanel from "./singleColorPickerPanel.container";

export default SingleColorPickerPanel;
